import { render, staticRenderFns } from "./ChangeBranchPassword.vue?vue&type=template&id=35409467&scoped=true&"
import script from "./ChangeBranchPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeBranchPassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangeBranchPassword.vue?vue&type=style&index=0&id=35409467&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35409467",
  null
  
)

export default component.exports